export const normalizeMembersForPayload = (members) =>
  (members || []).map((member) => ({
    id: member.id,
    member_email: member.member_email,
    ports: (member.ports || []).map((port) =>
      typeof port === "object" && port !== null ? port.id : port
    ),
  }));

export const memberPortOptions = (user, member) => {
  const options = new Map();
  [...(member.ports || []), ...(user.ports || []).map((entry) => entry.port)]
    .filter((port) => port && port.id)
    .forEach((port) => options.set(Number(port.id), {
      id: Number(port.id),
      name: port.name || `Port ${port.id}`,
    }));
  return [...options.values()];
};
